import { object, string, InferType } from 'yup';
import { deepPartialOrNullable } from '../../../../helpers';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { AiCareDocumentWorkDetailsSchema } from './AiCareDocumentWorkDetailsSchema';
import { AiDateSchema } from './AiDateSchema';

export const InterimCareSummaryAiGeneratedSchema = object().shape({
  patient: object()
    .shape({
      cancerType: string().nullable().notRequired(),
      dob: AiDateSchema,
      work: deepPartialOrNullable(AiCareDocumentWorkDetailsSchema)
        .nullable()
        .notRequired(),
    })
    .nullable()
    .notRequired(),

  expertSummary: object()
    .shape({
      motivation: string().nullable().notRequired(),
    })
    .nullable()
    .notRequired(),
});

export type InterimCareSummaryAiGenerated = InferType<
  typeof InterimCareSummaryAiGeneratedSchema
>;

export const InterimCareSummaryAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(InterimCareSummaryAiGeneratedSchema);

export type InterimCareSummaryAiGeneratedResponse = InferType<
  typeof InterimCareSummaryAiGeneratedResponseSchema
>;
